import Emitter from '@helpers/Emitter';
import { getCookie, setCookie } from '@resources/js/helpers/cookies';
const COOKIE_POLICY = 'cookie-policy';
const OPTIONAL_COOKIES = 'optional-cookies';
class CookiePolicy extends Emitter {
    setInteracted() {
        setCookie(COOKIE_POLICY, '1');
    }
    setOptional() {
        setCookie(OPTIONAL_COOKIES, '1');
        this.emit('optional-allowed');
    }
    hasInteracted() {
        return +getCookie(COOKIE_POLICY) === 1;
    }
    hasAllowedOptional() {
        return +getCookie(OPTIONAL_COOKIES) === 1;
    }
}
export default new CookiePolicy();
